import { Fragment, useContext, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { Route } from "../../../type/entities/route-type";
import cn from "../../../utils/classNames";
import RoutesList from "./RoutesList";

const RoutesListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [providerSelected, setProviderSelected] = useState<Route | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de rutas' },
        { name: 'Rutas', href: menuRoutes.routes.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de rutas" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'route') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => {
                                    setIsOpenFormDrawer(true)
                                    setProviderSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear ruta
                            </Button>
                        )
                    }
                </PageHeader>
                <RoutesList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} routeSelected={providerSelected} setRouteSelected={setProviderSelected} />
            </FiltersProvider>
        </Fragment>
    );
}

export default RoutesListWrapper;